import { Dashboard } from "@/models/dashboard/Dashboard";
import { isOwnOrganisationDashboard } from "./dashboardIdentity";

/** How two names compare as the reader sees them: case and surrounding spaces do not count. */
const normaliseName = (name: string): string =>
  name.trim().toLocaleLowerCase("da");

/**
 * The tenant's own organisation dashboard that already carries `name`, ignoring case and
 * surrounding spaces (LAR-661). Two dashboards that read the same in the header are easy to mix
 * up (LAR-280), so creating, cloning and renaming warn about it without blocking.
 *
 * Personal dashboards are nobody else's business and inherited ones belong to the parent
 * organisation, so neither is compared. `excludeId` keeps a dashboard being renamed from
 * clashing with itself.
 */
export const findOrganisationNameClash = (
  name: string,
  dashboards: Dashboard[],
  { excludeId }: { excludeId?: string } = {}
): Dashboard | null => {
  const candidate = normaliseName(name);
  if (!candidate) return null;

  return (
    dashboards.find(
      (dashboard) =>
        isOwnOrganisationDashboard(dashboard) &&
        dashboard.id !== excludeId &&
        normaliseName(dashboard.name) === candidate
    ) ?? null
  );
};
